/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalAlertBody/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MedicalAlertBody({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/Body/MedicalAlertBody"
  
}) {
let alertNameValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'name',
})
let alertValueValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'value',
})
  return (<React.Fragment
>
<div
  data-testid="MedicalAlertBody.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="alert.name"
 text={alertNameValueData}
 size="large"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={4}
 text=":"
 size="large"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="alert.value"
 text={alertValueValueData}
 size="large"
/>
</div>
{children}
</React.Fragment>)
}